import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';
import humanizeString,{formatSeconds}  from '../../utils'
import { useIsAdmin, useIsSuperAdmin, useMobileStore, useIsOrbitalUser } from '../../store';
import { apiClient } from '../../api_actions/index';
import { Modal, Select, Space, Input } from 'antd';
import React, { useState, useEffect } from 'react';
import './Users.scss';

export default function UsersPage() {
const isAdmin = useIsAdmin();
const isSuperAdmin = useIsSuperAdmin();
const isMobile = useMobileStore((state) => state.isMobile);
const [resetMFAModalVisible, setResetMFAModalVisible] = useState(false);
const [selectedUserForMFA, setSelectedUserForMFA] = useState(null);
const [searchInput, setSearchInput] = useState('');
const [customers, setCustomers] = useState([]);
const [selectedCustomer, setSelectedCustomer] = useState(null);
const [secondarySearchInput, setSecondarySearchInput] = useState('')
const isOrbitalUser = useIsOrbitalUser()
const { Search } = Input;

  const columns = [
    { 
      title: 'Email', 
      dataIndex: 'email', 
      key: 'email',
    },
    { 
      title: 'First Name', 
      dataIndex: 'first_name', 
      key: 'first_name',
      render: (text) => humanizeString(text)
    },
    { 
      title: 'Last Name', 
      dataIndex: 'last_name', 
      key: 'last_name',
      render: (text) => humanizeString(text)
    },
    { 
      title: 'Customer', 
      dataIndex: ['customer','name'], 
      key: 'customer',
      render: (text) => humanizeString(text)
    },
    {
      title: 'Role', 
      dataIndex: ['user_role','role_name'], 
      key: 'user_role',
      render: (text) => humanizeString(text)
    },
    {
      title: 'Logins',
      dataIndex: ['portal_log_summary','logins'], 
      key: 'logins',
      render: (text) => {
        if(text == 0){
          return ''
        } else { 
          return humanizeString(text)
        }
      },
      hideOnMobile: true,
    },
        {
      title: 'VMS (Monthly)',
      dataIndex: ['ovms_log_summary','total_time'], 
      key: 'total_time',
      render: (text) => {
        if(text == 0){
          return ''
        } else {
          return formatSeconds(text)
        }
      },
      hideOnMobile: true,
    }
  ];

  const formFields = [
    { 
      name: 'user_id', 
      label: 'User ID', 
      type: 'textarea', 
      placeholder: 'User ID',  
      disabled: true
    },
    {
      name: 'email',
      label: "Email",
      type: "email",
      placeholder: "Email",
      rules: [{ required: true, message: 'Must Enter an Email!'  }],
      disabled: !isSuperAdmin,

    },
    { 
      name: 'first_name',
      label: 'First Name',
      type: 'name',
      placeholder: 'First Name',  
      rules: [{ required: true, message: 'Must Enter a First Name!'  }],
      disabled: !isSuperAdmin,
    },
    { 
      name: 'last_name',
      label: 'Last Name',
      type: 'name',
      placeholder: 'First Name',  
      rules: [{ required: true, message: 'Must Enter a Last Name!'  }],
      disabled: !isSuperAdmin,
    },
    {
      name: ['customer','customer_id'],
      label: 'Customer',
      type: 'select',
      optionsEndpoint: '/read/customers',
      optionsLabel: ['name'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'customer_id',
      searchable: true,
      rules: [{ required: true, message: 'Must Select a Customer!'  }],
      disabled: !isSuperAdmin,
    },
    {
      name: ['user_role','user_role_id'],
      label: 'User Role',
      type: 'select',
      optionsEndpoint: '/read/userroles',
      optionsLabel: ['role_name'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'user_role_id',
      searchable: true,
      rules: [{ required: true, message: 'Must Select a user Role!'  }],
      disabled: !isSuperAdmin,
    },
    {
      name: 'alert_type_ids',
      mode: "multiple",
      allowClear: true,
      label: 'Contact Points',
      type: 'select',
      optionsEndpoint: '/read/alerttypes',
      optionsLabel: 'alert_type_name', // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'alert_type_id',
      searchable: true,
      rules: [{ required: true, message: 'Must Enter Alert Names!'  }],
      disabled: !isSuperAdmin,
    },
    { 
      name: 'contact_sms',
      label: 'Contact SMS',
      type: 'tel',
      placeholder: '000-000-0000', 
      disabled: !isSuperAdmin,
      rules: [
        {
          pattern: /^(\+1\s?)?(\(\d{3}\)|\d{3})[\s\-]?\d{3}[\s\-]?\d{4}$/,
          message: 'Please enter a valid phone number'
        }
      ]
    },
    {
      name: 'reset_mfa',
      label: 'Reset MFA Configuration',
      type: 'button',
      buttonType: 'primary',
      disabled: !isSuperAdmin,
      onClick: (record) => handleResetMFA(record),
    },

  ];

  // Function to load customers
  const loadCustomers = async () => {
    try {
      const result = await apiClient.post('read/customers');
      const customerOptions = result.data.map(customer => ({
        label: customer.name,
        value: customer.customer_id,
      }));
      setCustomers(customerOptions);
    } catch (error) {
      console.error('Failed to load customers:', error);
    }
  };

  useEffect(() => {
    loadCustomers();
  }, []);

  const handleResetMFA = (record) => {
    setSelectedUserForMFA(record);
    setResetMFAModalVisible(true);
  };

  const handleConfirmResetMFA = async () => {
    try {
      if (isSuperAdmin && selectedUserForMFA && selectedUserForMFA.email) {
        await apiClient.post("update/mfa-reset", { email: selectedUserForMFA.email });
      }
      setResetMFAModalVisible(false);
      setSelectedUserForMFA(null);
    } catch (error) {
      console.error('Failed to reset MFA:', error);
    }
  };

  return (
    <div className='container-wrapper'>
      <div>
        <h2>Site Users</h2>
      </div>
      <div className={`user-filter-wrapper ${isSuperAdmin ? 'admin-margin' : ''}`}>
        <div className="user-filter-controls">
          {(<label className="user-filter-label">Filter by:</label>)}
          {React.createElement(
            isMobile ? React.Fragment : Space.Compact,
            {},
            ...[
                isOrbitalUser && (
                    <Select
                        placeholder="Customer"
                        allowClear
                        value={selectedCustomer}
                        onChange={(value) => setSelectedCustomer(value)}
                        options={customers}
                    />
                ),
                <Search
                    placeholder="User Email..."
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                />,
                <Search
                    placeholder="User Name..."
                    value={secondarySearchInput}
                    onChange={(e) => setSecondarySearchInput(e.target.value)}
                />
            ].filter(Boolean)
        )}
        </div>
      </div>

      <ModalEditTable
        createEndpoint="create/users"
        readEndpoint="read/users"
        editEndpoint="update/users"
        deleteEndpoint="delete/users"
        searchQuery="user_email"
        searchInput={searchInput}
        secondarySearchQuery="user_name"
        secondarySearchInput={secondarySearchInput}
        selectedCustomer={selectedCustomer}
        columns={columns}
        formFields={formFields}
        canDelete={isSuperAdmin && !isMobile}
        canCreate={isSuperAdmin}
        canSave={isSuperAdmin}
        showAddButton={!isMobile}
      />

      <Modal
        title="Reset MFA Configuration"
        open={resetMFAModalVisible}
        onCancel={() => setResetMFAModalVisible(false)}
        onOk={handleConfirmResetMFA}
        okText="Yes, Reset"
        okButtonProps={{ danger: true }}
        cancelText="Cancel"
      >
        <p>
          Are you sure you want to reset MFA for <strong>{selectedUserForMFA?.email}</strong>?
        </p>
        <p>
          They will need to reconfigure their authenticator app on their next login.
        </p>
      </Modal>
    </div>
  );
}